import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Losses37_4Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Losses37_4 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("LOSSES_CATEGORY") || "Losses for everything in this category"}
        subDescription={t("LOSSES_37_4_DESC") || "This is where you record any losses in this category relating to water, packaging and product components. In the 'Installation and Construction' section, you could record, for example, that you glue something and some of the weight is lost due to off-gassing during the drying phase."}
        isNormal={true}
        number={"37.4"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`losses-37-4-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Losses37_4Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Losses37_4;

